export const ANONYMOUS_KEY = `DTY-Anonymous`;
export const APPLICATION = `Web`;
export const APPLICATION_TYPE = `Patient`;

// Local Config

// export const BASE_API_URL = `https://localhost:7080/`;
// export const ENVIRONMENT = `dev`;
// export const INVOICE_LINK = `https://app.sandbox.qbo.intuit.com/app/invoice?txnId=`;
// export const CLOUD_URL = `https://storage.googleapis.com/download/storage/v1/b/dtystage/o/`;

// Stage Config

// export const BASE_API_URL = `http://34.148.250.95:91/`; // New GCP Stage Api
// export const ENVIRONMENT = `dev`;
// export const INVOICE_LINK = `https://app.sandbox.qbo.intuit.com/app/invoice?txnId=`;
// export const CLOUD_URL = `https://storage.googleapis.com/download/storage/v1/b/dtystage/o/`;

// Live Config

export const BASE_API_URL = `https://api2.doctorstoyou.com/`;
export const ENVIRONMENT = `production`;
export const INVOICE_LINK = `https://app.qbo.intuit.com/app/invoice?txnId=`;
export const CLOUD_URL = `https://storage.googleapis.com/download/storage/v1/b/dty/o/`;

// Extra - old api urls
// export const BASE_API_URL = `http://172.174.160.184:91/`;
// export const BASE_API_URL = `https://web2.anasource.com/dtyapi/`;
